import { SovosToolbar, SovosToolbarActions, SovosToolbarColumn, SovosToolbarFilter, SovosToolbarGroup } from "mosaic-react";
import styles from "./DataGrid.module.sass";
import React from "react";
import { useGridApiContext, GridPreferencePanelsValue } from "@mui/x-data-grid";
const Toolbar = ({
  tabs,
  isPreferencesPanelOpen,
  isFilterPanelOpen,
  extraActions = [],
  availableFilters,
  filterArray
}) => {
  const gridRef = useGridApiContext();
  const Tabs = tabs?.[0]?.component;
  const toggleFilterPanel = () => {
    if (!isFilterPanelOpen) {
      gridRef.current.showFilterPanel();
    } else {
      gridRef.current.hideFilterPanel();
    }
  };
  const filterArrayCount = (filterArray || []).reduce((acc, arrayFilter) => {
    const {
      filters = []
    } = arrayFilter || [[]];
    acc += filters?.length;
    return acc;
  }, 0);
  const toggleColumnPanel = () => {
    // Toggle the display state of the column panel
    if (!isPreferencesPanelOpen) {
      gridRef.current.showPreferences(GridPreferencePanelsValue.columns);
    } else {
      gridRef.current.hidePreferences();
    }
  };
  return /*#__PURE__*/React.createElement(SovosToolbar, null, Tabs ? /*#__PURE__*/React.createElement(SovosToolbarGroup, {
    className: styles["toolbar-group"]
  }, /*#__PURE__*/React.createElement(Tabs, tabs?.[0]?.props)) : null, /*#__PURE__*/React.createElement(SovosToolbarGroup, {
    className: `${Tabs ? "" : styles["toolbar-group"]}`
  }, /*#__PURE__*/React.createElement(SovosToolbarActions, null, extraActions, /*#__PURE__*/React.createElement(SovosToolbarColumn, {
    onClick: toggleColumnPanel
  }), availableFilters?.length && /*#__PURE__*/React.createElement(SovosToolbarFilter, {
    appliedFiltersCount: filterArrayCount || 0,
    onClick: toggleFilterPanel
  }))));
};
export default Toolbar;